(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvDialogFooterButtons', drvDialogFooterButtons);

    function drvDialogFooterButtons() {
        var directive = {
            restrict: 'E',
            scope: {
                cancelOnClick: '&?', 
                okOnClick: '&?',
                cancelText: '<?',
                okText: '<?',
                disableCancel: '<?',
                disableOk: '<?',
                hideCancel: '<?',
                hideOk: '<?'
            },
            template:
                '<div>' +
                '   <md-button class="md-raised" ng-click="cancelOnClick()" type="button" ng-disabled="disableCancel" ng-if="!hideCancel">' +
                '       {{cancelText || \'Cancel\'}}' +
                '   </md-button>' +
                '   <md-button autofocus class="md-raised main-button" ng-click="okOnClick()" type="button" ng-disabled="disableOk" ng-if="!hideOk">' +
                '       {{okText || \'Ok\'}}' +
                '   </md-button>' +
                '</div>'
        };
        return directive;
    }
})();